import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import PayrollReceiptSheet from "@/components/PayrollReceiptSheet";
import { Printer } from "lucide-react";
import { toast } from "sonner";

export default function PublicPayrollReceipt() {
  const { token } = useParams();
  const [entry, setEntry] = useState(null);
  const [error, setError] = useState("");

  const load = async () => {
    try {
      const { data } = await api.get(`/public/payroll-receipts/${token}`);
      setEntry(data);
    } catch (err) {
      setError(err.response?.data?.detail || "Enlace no válido");
    }
  };
  useEffect(() => { load(); }, [token]); // eslint-disable-line react-hooks/exhaustive-deps

  const submitSignature = async (dataUrl) => {
    try {
      await api.post(`/public/payroll-receipts/${token}/sign`, { signature: dataUrl });
      toast.success("¡Recibo firmado, gracias!");
      load();
    } catch (e) {
      toast.error(e.response?.data?.detail || "No se pudo guardar la firma");
      throw e;
    }
  };

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center p-6 text-center" style={{ background: "#0a0f1d" }}>
        <div>
          <div className="text-4xl mb-3">⚠️</div>
          <div className="text-slate-200 font-semibold">{error}</div>
          <div className="text-slate-500 text-sm mt-2">Solicita un nuevo enlace de firma a Corporation Inconti.</div>
        </div>
      </div>
    );
  }
  if (!entry) return <div className="min-h-screen flex items-center justify-center text-slate-400" style={{ background: "#0a0f1d" }}>Cargando…</div>;

  return (
    <div className="min-h-screen" style={{ background: "#0a0f1d" }} data-testid="public-payroll-receipt-page">
      <div className="no-print sticky top-0 z-10 px-4 py-3 flex items-center justify-between gap-2"
        style={{ borderBottom: "1px solid rgba(148,163,184,0.2)", background: "rgba(5,8,18,0.9)", backdropFilter: "blur(8px)" }}>
        <div className="text-xs text-slate-300 uppercase tracking-widest font-semibold">Recibo de nómina · Inconti</div>
        <button data-testid="public-print-receipt-btn" onClick={() => window.print()} className="px-3 py-1.5 text-xs uppercase tracking-widest font-semibold rounded-sm flex items-center gap-2 text-slate-200" style={{ border: "1px solid rgba(148,163,184,0.35)" }}>
          <Printer className="w-4 h-4" /> Imprimir
        </button>
      </div>
      <div className="py-6 px-2 sm:px-4">
        <PayrollReceiptSheet entry={entry} submitSignature={submitSignature} />
      </div>
    </div>
  );
}
